import { Helmet } from "react-helmet-async";
 



const HomeSchema = () => {

const schemaData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Your Friend, My Friend",
    "url": "https://yourfriendmyfriend.ie",
    "logo": "https://yourfriendmyfriend.ie/logo123.png",
    "sameAs": [
      "https://www.facebook.com/yourfriendmyfriend",
      "https://www.instagram.com/yourfriendmyfriend",
      "https://x.com/yourfriendmyfriend"
    ],
    "description":
      "Connecting Ireland's most eligible singles. It's time to ditch the dating apps and join Ireland's dating revolution. Your Friend",
    "founder": {
      "@type": "Person",
      "name": "Your Founder Name"
    },
    "publisher": {
      "@type": "Your Friend, My Friend",
      "name": "Your Friend, My Friend",
      "logo": {
        "@type": "ImageObject",
        "url": "https://yourfriendmyfriend.ie/logo123.png"
      }
    }
  };

  return (
    <>
      <Helmet>
        {/* Schema.org JSON-LD */}
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
         <meta name="robots" content="index, follow" />
        <meta property="og:site_name" content="Your Friend, My Friend" />
        <meta property="og:title" content="Your Friend, My Friend" />
        <meta property="og:url" content="https://yourfriendmyfriend.ie" />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content="Connecting Ireland's most eligible singles. It's time to ditch the dating apps and join Ireland's dating revolution. Your Friend"
        />
        <meta
          property="og:image"
          content="https://yourfriendmyfriend.ie/logo123.png"
        />
        <meta property="og:image:width" content="851" />
        <meta property="og:image:height" content="867" />

      
        <meta name="twitter:title" content="Your Friend, My Friend" />
        <meta
          name="twitter:image"
          content="https://yourfriendmyfriend.ie/logo123.png"
        />
        <meta name="twitter:url" content="https://yourfriendmyfriend.ie" />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:description"
          content="Connecting Ireland's most eligible singles. It's time to ditch the dating apps and join Ireland's dating revolution. Your Friend"
        />
        <link rel="canonical" href="https://yourfriendmyfriend.ie" />
      </Helmet>
    </>
  );
};
 
export default HomeSchema;